import { defineRecipe } from '@chakra-ui/react';
import fonts from 'src/theme/fonts';

const Heading = defineRecipe({
  base: {
    fontFamily: fonts.bold,
    lineHeight: '1.5em',
    letterSpacing: '-0.02em',
    color: 'podcastShade700',
    fontWeight: 'normal !important',
  },
  variants: {
    size: {
      none: {},
      h1: {
        fontSize: { sm: '30px', md: '36px', lg: '48px' },
        lineHeight: { sm: '42px', md: '48px', lg: '60px' },
      },
      h2: {
        fontSize: { sm: '24px', md: '30px', lg: '36px' },
        lineHeight: { sm: '36px', md: '42px', lg: '48px' },
      },
      h3: {
        fontSize: { sm: '20px', md: '24px', lg: '30px' },
        lineHeight: { sm: '30px', md: '36px', lg: '42px' },
      },
      h4: {
        fontSize: { sm: '20px', md: '24px' },
        lineHeight: { sm: '20px', md: '36px' },
      },
      h5: {
        fontSize: '20px',
        lineHeight: '30px',
      },
    },
    visual: {
      none: {},
      statsHeader: {
        fontSize: '16px',
        lineHeight: '24px',
      },
      dialogTitle: {
        m: '0',
        fontSize: '20px',
        lineHeight: '30px',
      },
      toastTitle: {
        color: 'white',
        fontSize: '16px',
        lineHeight: '18px',
        m: '0',
        wordBreak: 'break-word',
      },
      subscription: {
        m: '0',
        color: 'podcastShade500',
        fontSize: '22px',
        lineHeight: '24px',
      },
      loading: {
        m: '0',
        color: 'podcastShade600',
        fontSize: '20px',
        lineHeight: '30px',
      },
      contentBoxHeading: {
        fontSize: '22px',
        color: 'podcastShade600',
        lineHeight: '30px',
        m: '0 0 18px',
        textAlign: 'left',
      },
      sectionHeader: {
        fontFamily: fonts.bold,
        fontSize: '24px',
        color: 'podcastShade700',
        lineHeight: '36px',
        w: 'max-content',
        m: '0 0 3px',
        p: 0,
      },
    },
  },
  defaultVariants: {
    visual: 'none',
    size: 'none',
  },
});

export default Heading;
